import React from 'react';
import PropTypes from 'prop-types';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import { useMediaQuery } from '@mui/material';

import ParentShipmentSummaryContent from './ParentShipmentSummaryContent';

const ParentShipmentSummary = ({ totalProposedVolume, shipmentData }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'), { noSsr: true });

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      {isMobile ? (
        <Accordion defaultExpanded sx={{ width: '100%' }}>
          <AccordionSummary
            aria-controls="parent-shipment-details-content"
            expandIcon={<ExpandMoreIcon sx={{ color: 'primary.main' }} />}
            id="parent-shipment-details-header"
          >
            <Typography variant="body2">Shipment Details</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <ParentShipmentSummaryContent
              shipmentData={shipmentData}
              totalProposedVolume={totalProposedVolume}
            />
          </AccordionDetails>
        </Accordion>
      ) : (
        <Card elevation={1} sx={{ width: { lg: '250px', sm: '100%' } }}>
          <CardHeader
            slotProps={{
              title: { variant: 'body2' },
            }}
            title="Shipment Details"
          />
          <Divider />
          <CardContent sx={{ backgroundColor: 'surface.light' }}>
            <ParentShipmentSummaryContent
              shipmentData={shipmentData}
              totalProposedVolume={totalProposedVolume}
            />
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

ParentShipmentSummary.propTypes = {
  shipmentData: PropTypes.shape({}).isRequired,
  totalProposedVolume: PropTypes.number.isRequired,
};

export default ParentShipmentSummary;
